import React, { useContext, useState, useEffect } from "react";
import Store from "store";
import { ReactComponent as IconSend } from 'icon/ion-send.svg';


export function Editor({block}) {
  const { state, dispatch } = useContext(Store);
  const [ text, setText ] = useState(block.props.default || '');
  const [ isInvalid, setIsInvalid ] = useState(false);
  const [ isReveal, setIsReveal ] = useState(false);
  const [ hasFocus, setHasFocus ] = useState(false);
  const [ refBlock, setRefBlock ] = useState();


  // Reveal the block with animation after specific delay
  //
  useEffect(() => {
    setTimeout(() => {
      if (refBlock !== undefined) {
        setIsReveal(true);
      }
    }, (block.props.delay || 0.5) * 1000 );
  }, [refBlock]);


  useEffect(() => {
    if (state.user.var && block.name !== '' && block.name in state.user.var) {
      setText(state.user.var[block.name]);
    }
  }, [])


  function nl2br(str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  }

  function strip(html){
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
 }


  const save = () => {
    if (!validate()) {
      setIsInvalid(true);
      setTimeout(() => {
        setIsInvalid(false);
      }, 2000);
      return;
    }

    const msg = {
      type: block.type,
      align: block.align,
      content: nl2br(strip(text)),
    }

    dispatch({ type: "RESPONSE_ADD", payload: msg });
    dispatch({ type: "VARIABLE_SAVE", payload: {key: block.name, value: msg.content} });
    dispatch({ type: "FORM_NEXT" });
  }

  const validate = () => {

    if (text === '' && block.validation.required === true) {
      return false;
    }

    return true;
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      save();
    }
  }

  const onSkip = () => {
    setText('');
    save();
  }

  const autoGrow = (e) => {
    const element = e.target;
    if (element.scrollHeight > 60) {
      element.style.height = "5px";
      element.style.height = element.scrollHeight + "px";

      var objDiv = document.getElementsByClassName('chatbox-wrapper')[0];
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  }



  return (
    <li className={`block-${block.align}`}>
      <div
        className={
          `block-${block.type} editor` +
          (isInvalid ? ' is-invalid' : '') +
          (hasFocus  ? ' has-focus' : '') +
          (isReveal  ? ' reveal' : '')
        }
        ref={(e) => setRefBlock(e)}
      >
        <textarea
          autoFocus
          placeholder={block.props.placeholder}
          value={text}
          onChange={ (e) => setText(e.target.value) }
          onFocus={() => setHasFocus(true)}
          onBlur={() => setHasFocus(false)}
          onKeyUp={autoGrow}
        />
        <button className="btn-send" onClick={save} />
      </div>

      {/*
      <div className="skip">
        <a href="#" onClick={onSkip}>Skip</a>
      </div>
      */}
    </li>
  )

}


export function Message({block}) {
  let content = block.content;

  if (content === '') {
    content = 'N/A';
  }

  return (
    <div className={`block-${block.type} message`} dangerouslySetInnerHTML={{__html: content}} />
  )
}
